import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { CUSTOMER_STATUS } from '../../../data/constant';
import TableLayout from '../layout/TableLayout';
import httpClient from '../../../http/HttpRequest';
import { CUSTOMER_LIST } from '../../../data/url';
import { useParams } from 'react-router-dom';
import FormLayout from '../layout/FormLayout';

export default function CustomerList() {

     const { customerType } = useParams();
     let title = "customer_list";
     let newBtnLink = "root/customer/add";
     let cType = 0;
     if (customerType === 'vendor') {
          title = "vendor_list";
          newBtnLink = "root/vendor/add";
          cType = 1;
     }
     const [list, setCustomerData] = useState([]);
     const tableHeaders = ['#', 'name', 'mobile', 'email', 'balance', 'status', 'edit'];
     const keys = ["full_name", "mobile", "email", "pending_amount", "status", "btnEdit"];
     const btnData = {
          btnEdit: { name: "edit", link: "/root/" + customerType + "/edit" },
     }
     useEffect(() => {
          getCustomerData({ customerType: cType });
     }, [customerType]);

     const getCustomerData = async (payload) => {
          const res = await httpClient.post(CUSTOMER_LIST, payload);
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    setCustomerData(result.data);
               }
          }
     }

     const [formData, setFormData] = useState({
          formTitle: 'Search Customer',
          formFields: [
               { label: 'from_date', id: 'from_date', type: 'date', name: 'from_date', value: '', className: "col-md-2" },
               { label: 'to_date', id: 'to_date', type: 'date', name: 'to_date', value: '', className: "col-md-2" },
               { label: customerType, id: 'customer', type: 'text', name: 'name', value: '', className: "col-md-3", placeholder: 'Enter name' },
               { label: 'mobile', id: 'mobile', type: 'number', name: 'mobile', value: '', className: "col-md-3", placeholder: 'Enter mobile' },
          ],
          formErrors: { from_date: '', to_date: '', name: '', mobile: '' },
     });

     const handleFieldChange = (fieldName, value) => {
          setFormData((prevFormData) => {
               const updatedFormFields = prevFormData.formFields.map((field) =>
                    field.name === fieldName ? { ...field, value: value } : field
               );
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     }

     const handleFieldBlur = () => { }

     const handleSubmit = (e) => {
          e.preventDefault();
          let post = { customerType: cType };
          const updatedFormFields = formData.formFields.map((field) => {
               post[field.name] = field.value;
               return field;
          });
          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
          }));
          getCustomerData(post);
     }

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader
                         title={title}
                         newButton="new"
                         newButtonLink={newBtnLink}
                    />
                    <div className="col-lg-12 grid-margin stretch-card">
                         <div className="card">
                              <div className="card-body">
                                   <div className='mb-2'>
                                        <FormLayout
                                             formTitle={formData.formTitle}
                                             formFields={formData.formFields}
                                             formErrors={formData.formErrors}
                                             onFieldChange={handleFieldChange}
                                             onFieldBlur={handleFieldBlur}
                                             onSubmit={handleSubmit}
                                             isModal
                                             search
                                        />
                                   </div>
                                   <TableLayout
                                        headers={tableHeaders}
                                        keys={keys}
                                        tableData={list}
                                        id="customer_id"
                                        btnData={btnData}
                                        statusKey="status"
                                        statusObject={CUSTOMER_STATUS}
                                        numberKey={["pending_amount"]}
                                   />
                              </div>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
